module.exports = __webpack_public_path__ + "img/flower_leaf_32.35493daa.png";